// Katapult Boost is shown as a fixed, non-negotiated price across the Offer Page,
// Price Tag Disclosures, and Checkout - kept in one place so all three agree. Katapult
// Protection+'s price is not fixed - it comes from the checkout response's
// kplus_monthly_amount instead (see KPLUS_EXCLUDED_STATES below for its availability rule).
export const KATAPULT_BOOST_PRICE = '$11.99';

// States where Katapult Protection+ is not offered, regardless of the retailer-level feature
// gate. Shared between DisplayOfferedLeaseDetailsB.js and PriceTagDisclosures.js.
export const KPLUS_EXCLUDED_STATES = ['CA', 'HI', 'IN', 'MN', 'NJ', 'PR', 'UT', 'WI', 'WY'];

// States where Katapult Boost is not offered, regardless of the Enable_Katapult_Boost feature
// gate. Shared between DisplayOfferedLeaseDetails/index.js's post-submit enrollment check,
// DisplayOfferedLeaseDetailsB.js's display gating, and PriceTagDisclosures.js.
export const BOOST_EXCLUDED_STATES = ['OK', 'UT', 'WI'];

// Single source of truth for "is Katapult Protection+ available" - the checkout response's
// kplus_feature_gate_enabled and kplus_monthly_amount, plus its own billing_state, must all be
// present and the state must not be excluded. Used by the Offer Page, Price Tag Disclosures,
// Lease Agreement, and Checkout so none of them can drift out of agreement on this rule.
export function isKplusAvailable(checkout) {
  const billingState = checkout?.billing_state;
  const isStateEligible = Boolean(billingState) && !KPLUS_EXCLUDED_STATES.includes(billingState);
  return Boolean(checkout?.kplus_feature_gate_enabled && checkout?.kplus_monthly_amount && isStateEligible);
}

// Single source of truth for "is Katapult Boost available" - the Enable_Katapult_Boost feature
// gate plus the customer's billing state (a separate redux field from the checkout response's
// own billing_state - see loanInfo.billingState). Used by the same four places as above.
export function isBoostAvailable(checkout) {
  const billingState = checkout?.billing_state;
  const isStateEligible = Boolean(billingState) && !BOOST_EXCLUDED_STATES.includes(billingState);
  return Boolean(checkout?.kboost_feature_gate_enabled) && isStateEligible;
}

// States that get the Katapult Protection+ Acknowledgment document specifically - an allow-list,
// independent of KPLUS_EXCLUDED_STATES (IN is excluded from general KP+ availability but is one
// of the states that gets this particular Acknowledgment). Only LeaseAgreement.js's separate
// Acknowledgment row uses this - every other KP+ display uses isKplusAvailable.
export const KPLUS_ACKNOWLEDGEMENT_STATES = ['IN', 'CO', 'CT', 'ME'];

export function isKplusAcknowledgementAvailable(checkout) {
  const billingState = checkout?.billing_state;
  const isStateEligible = KPLUS_ACKNOWLEDGEMENT_STATES.includes(billingState);
  return Boolean(checkout?.kplus_feature_gate_enabled && checkout?.kplus_monthly_amount && isStateEligible);
}
